import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import Dashboard from "../../../layouts/Dashboard";
import { Text } from "@pushpress/shared-components";
import { AppContext } from "../../../context/app";
import BookDemo from "./BookDemo";
import SetupGuide from "./SetupGuide/SetupGuide";
import styles from "./GetStartedLanding.module.scss";
import InsuranceMessage from "../GetStartedExperiments/InsuranceMessage";
import { useExperiment } from "../../../hooks/useExperiment";

function GetStartedLanding() {
  const app = useContext(AppContext);
  const { useExperimentValue } = useExperiment();
  const { user } = app;

  const isInsuranceExperimentEnabled = useExperimentValue(
    "pushpress_insurance_banner",
  );

  const helloText = user?.first_name
    ? `Hello, ${user.first_name}! 👋`
    : "Hello! 👋";

  return (
    <>
      <Helmet>
        <title>Get Started</title>
      </Helmet>
      <Dashboard scrollableContent disableContentPadding>
        <div className={styles.container}>
          <div className={styles.innerContainer}>
            <Text style={{ marginBottom: 20 }} variant="heading-3">
              {helloText}
            </Text>
            <div
              className={
                "tw-flex tw-flex-col md:tw-flex-row tw-w-full tw-gap-4"
              }
            >
              <BookDemo />
              {isInsuranceExperimentEnabled && <InsuranceMessage />}
            </div>
          </div>
          <div className={styles.innerContainer}>
            <SetupGuide />
          </div>
        </div>
      </Dashboard>
    </>
  );
}

export default GetStartedLanding;
